/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DunningLevelDto
 */
export interface DunningLevelDto {
    /**
     * The Level name
     * @type {string}
     * @memberof DunningLevelDto
     */
    name: string;
    /**
     * The description of level
     * @type {string}
     * @memberof DunningLevelDto
     */
    description?: string;
    /**
     * Id of dunning level
     * @type {string}
     * @memberof DunningLevelDto
     */
    id: string;
}

/**
 * Check if a given object implements the DunningLevelDto interface.
 */
export function instanceOfDunningLevelDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function DunningLevelDtoFromJSON(json: any): DunningLevelDto {
    return DunningLevelDtoFromJSONTyped(json, false);
}

export function DunningLevelDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DunningLevelDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'id': json['id'],
    };
}

export function DunningLevelDtoToJSON(value?: DunningLevelDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'id': value.id,
    };
}

